module.exports = __webpack_public_path__ + "assets/c_american-express-3fd3f0.svg";